import { render, staticRenderFns } from "./Deliverynote.vue?vue&type=template&id=0a4c1bc4&scoped=true&"
import script from "./Deliverynote.vue?vue&type=script&lang=js&"
export * from "./Deliverynote.vue?vue&type=script&lang=js&"
import style0 from "./Deliverynote.vue?vue&type=style&index=0&id=0a4c1bc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c1bc4",
  null
  
)

export default component.exports